import styled from 'styled-components';

export const Container = styled.div`
  padding: 10px 0 10px 0;
  color: #000;
`;
